import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const SongwriterNameTooltip = () => (
    <CustomToolTip
        type="?"
        inverse
        place="right"
        info="Provide the name you’re typically credited with as a writer. If you use variations of the name or pseudonyms, you’ll have a chance to search for those in the following step."
    />
)

export default SongwriterNameTooltip
